import React from 'react';
import PropTypes from 'prop-types';
import TwoColumnTable from '../two-column-table/TwoColumnTable';
import FormatUtils from 'utils/format';

const formatRows = ({
    currencyCode,
    commuterAvgPrice,
    weekendAvgPrice,
    eventAvgPrice,
    overnightAvgPrice,
}) => {
    const rowOrder = [
        {label: 'Commuter Parking', data: commuterAvgPrice},
        {label: 'Weekend Parking', data: weekendAvgPrice},
        {label: 'Event Parking', data: eventAvgPrice},
        {label: 'Overnight Parking', data: overnightAvgPrice},
    ];
    const currencySymbol = FormatUtils.currencySymbol(currencyCode);
    const tableRows = rowOrder.reduce((accmRows, currentRow) => {
        if (currentRow.data) {
            accmRows.push([
                currentRow.label,
                `${currencySymbol}${Math.ceil(
                    currentRow.data.low
                )} - ${currencySymbol}${Math.ceil(currentRow.data.high)}`,
            ]);
        }

        return accmRows;
    }, []);

    return tableRows;
};

const DynamicRatesTable = ({slice, dynamicRatesData, isMidFunnel}) => {
    const tableTitle = slice.primary.table_title;
    const columnTitles = [
        slice.primary.left_column_title,
        slice.primary.right_column_title,
    ];
    const tableRows = formatRows(dynamicRatesData);

    return (
        <TwoColumnTable
            tableTitle={tableTitle}
            columnTitles={columnTitles}
            tableRows={tableRows}
            isMidFunnel={isMidFunnel}
        />
    );
};

/* eslint-disable camelcase */
DynamicRatesTable.propTypes = {
    slice: PropTypes.shape({
        primary: PropTypes.shape({
            table_title: PropTypes.string.isRequired,
            left_column_title: PropTypes.string.isRequired,
            right_column_title: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    dynamicRatesData: PropTypes.shape({
        currencyCode: PropTypes.string,
        commuterAvgPrice: PropTypes.shape({
            high: PropTypes.number,
            low: PropTypes.number,
        }),
        weekendAvgPrice: PropTypes.shape({
            high: PropTypes.number,
            low: PropTypes.number,
        }),
        eventAvgPrice: PropTypes.shape({
            high: PropTypes.number,
            low: PropTypes.number,
        }),
        overnightAvgPrice: PropTypes.shape({
            high: PropTypes.number,
            low: PropTypes.number,
        }),
    }),
    isMidFunnel: PropTypes.bool,
};

export default DynamicRatesTable;
